module.exports = __webpack_public_path__ + "media/logos/fcb-d467a8b7.png";